/*
 * Types.
 */

interface DeferredPromiseManager<TValue> {
  bindPending(
    resolve: (value: TValue | PromiseLike<TValue>) => void,
    reject: (reason?: unknown) => void,
  ): void;
  resolveWith(value: TValue | PromiseLike<TValue>): void;
  cancel(reason: Error): void;
}

/*
 * Helpers.
 */

/**
 * Creates a singleton that can manage the latest `resolve` / `reject` pair for an in-flight `Promise`.
 * Provides helpers to bind, cancel, and resolve the `Promise`.
 */
export function createDeferredPromiseManager<T>(): DeferredPromiseManager<T> {
  let resolve: ((value: T | PromiseLike<T>) => void) | undefined;
  let reject: ((reason?: unknown) => void) | undefined;

  return {
    bindPending(res, rej) {
      resolve = res;
      reject = rej;
    },
    resolveWith(value) {
      resolve?.(value);
      resolve = undefined;
      reject = undefined;
    },
    cancel(reason: Error) {
      reject?.(reason);
      resolve = undefined;
      reject = undefined;
    },
  };
}
